import * as React from "react";
import {Typography, Button, DialogTitle, Dialog} from "@mui/material";
import { styled } from "@mui/material/styles";
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import { apiExcludeCases } from "../../../utils/api";
import { SnackbarContext } from "../../../context/AlertsContext";

type Props = {
    selected: any;
    open: boolean;
    handleClose: () => void;
    handleAfterExclusion: () => void
    serviceLine:string;
};

const StyledDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    }
}));

const StyledButton = styled(Button)({
    borderRadius: "4px",
    textTransform: "none",
    flexGrow: 1,
    maxWidth: '100px',
    maxHeight: '40px',
    minWidth: '100px',
    minHeight: '40px'
});

export const ExcludeCases = ({
    selected,
    open,
    handleClose,
    handleAfterExclusion,
    serviceLine,
    ...props
}: Props) => {
    const {openSnackbar} = React.useContext(SnackbarContext);
    const handleExcludeClick = async () => {
        if (!selected || selected.length === 0) return;

        const cases = selected.map((s: any) => ({
            processInstanceGuid: s.cmx_process_id,
            isChargeable: false,
        }));

        try {
            await apiExcludeCases(cases, serviceLine);
            handleClose();
        } catch (err) {
            console.error("Error excluding cases:", err);
        }
        openSnackbar(`${selected.length} case${selected.length > 1 ? "s" : ""} ${selected.length > 1 ? "are" : "is"}
         being excluded. It may take a few minutes for the view to recognize the changes.`,"info");
        handleAfterExclusion();
    };
    return (
        <StyledDialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
            <DialogTitle sx={{ m: 0, p: 2 }} id="reassign-title">
                Exclude Cases
            </DialogTitle>
            <IconButton
                aria-label="close"
                onClick={handleClose}
                sx={{
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    color: (theme) => theme.palette.grey[500],
                }}
            >
                <CloseIcon />
            </IconButton>
            <DialogContent>
               <Typography gutterBottom sx={{ mb: 2 }}>
                  {selected ? selected.length : 0} case{selected && selected.length !== 1 ? "s" : ""} selected.
                   <br />
                   You are about to exclude {selected ? selected.length : 0} case
                   {selected && selected.length !== 1 ? "s" : ""}. Are you sure you want to do this? This cannot be undone.
                </Typography>
            </DialogContent>
                <DialogActions>
                    <StyledButton variant="outlined" onClick={handleClose}>
                        Cancel
                    </StyledButton>
                    <StyledButton variant="contained"  disabled={!selected || selected.length === 0} sx={{ml: 5}} onClick={handleExcludeClick}>
                        Exclude
                    </StyledButton>
                </DialogActions>
        </StyledDialog>
    )
}